import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../../Containers/Config/index.js';
import { CLIENT_TOTAL_BOOKINGS, CLIENT_TOTAL_BOOKINGS_ERROR, CLIENT_TOTAL_BOOKINGS_SUCCESS } from '../../../../../actionType.js';
import apiCall from '../../../../../apiCall.js';

function* clientTotalBookings({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: CLIENT_TOTAL_BOOKINGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CLIENT_TOTAL_BOOKINGS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CLIENT_TOTAL_BOOKINGS_ERROR, payload: error });
  }
}

export function* watchClientTotalBookings() {
  yield takeEvery(CLIENT_TOTAL_BOOKINGS, clientTotalBookings);
}

function* clientTotalBookingsSaga() {
  yield all([fork(watchClientTotalBookings)]);
}

export default clientTotalBookingsSaga;
